<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="dense" :label="$lang.dense" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="icon" :label="$lang.icon" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="title" :label="$lang.title" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="actions" :label="$lang.actions" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <card>
          <card-text>
            <toolbar :dense="dense" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white">
              <toolbar-icon v-if="icon">
                <icon name="cat" color="white" />
              </toolbar-icon>
              <toolbar-title text="Toolbar Title" v-if="title" />
              <toolbar-actions v-if="actions">
                <btn v-for="button in actionButtons" :key="button" elevation="none" bg-color="transparent" color="white" :icon="button" :class="['mr-1']" :bg-color-lightness="null" :color-lightness="null" />
              </toolbar-actions>
            </toolbar>
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageToolbar',
  mixins: [
    methods
  ],
  data () {
    return {
      dense: true,
      icon: true,
      title: true,
      actions: true,
      actionButtons: []
    }
  },
  mounted () {
    this.getExternalData('toolbar.json', 'actionButtons')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/toolbar.vue